import './styles/CreatePage.scss';

import { Button, Divider, Grid2 } from '@mui/material';

import { Form, Formik, FormikProps } from 'formik';
import { TFunction } from 'i18next';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';

import { actions as FormErrorActions } from 'app/containers/Dashboard/FormError/slice';
import { translations } from 'locales/i18n';
import useUnmountEffect from 'utils/hooks/useUnmountEffect';
import ObjectSchema, { ObjectShape } from 'yup/lib/object';

import SubmittingLoader from '../Util/SubmittingLoader';

interface Props<T = any> {
  validationSchema: (t: TFunction) => ObjectSchema<ObjectShape>;
  initialValues: any;
  handleSaveClick: (values: T) => void;
  submittingState: [boolean, React.Dispatch<React.SetStateAction<boolean>>];
  disabledCancel: boolean;
  children: (data: FormikProps<T>) => JSX.Element | null | undefined;
  xs?: number;
}

const CreatePage = <T extends {} = Record<string, any>>(props: Props<T>) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [submitting, setSubmitting] = props.submittingState;

  useUnmountEffect(() => {
    dispatch(FormErrorActions.close());
  });

  return (
    <Formik
      initialValues={props.initialValues}
      validationSchema={props.validationSchema(t)}
      onSubmit={values => {
        setSubmitting(true);
        props.handleSaveClick(props.validationSchema(t).cast(values) as T);
      }}
      validateOnMount
      // validate={values =>
      //   validateForm(values, yup.object().shape(props.validationSchema(t)), dispatch)
      // }
    >
      {formik => (
        <Form>
          <Grid2 container flex={1}>
            {props.children(formik)}
            <Grid2 size={{ xs: 12, md: props.xs ?? 10 }}>
              <Divider />
            </Grid2>
            <Grid2
              container
              gap={2}
              size={{ xs: props.xs ?? 10 }}
              className="create-button-container"
            >
              <Grid2>
                <Button
                  variant="outlined"
                  onClick={() => {
                    dispatch(FormErrorActions.close());
                    navigate(-1);
                  }}
                  disabled={props.disabledCancel}
                >
                  {t(translations.common.cancel())}
                </Button>
              </Grid2>
              <Grid2>
                <span
                  style={{
                    position: 'relative'
                  }}
                >
                  <Button
                    variant="contained"
                    style={{ color: 'white' }}
                    type="submit"
                    disabled={submitting || !formik.isValid}
                  >
                    {t(translations.common.save())}
                  </Button>
                  {submitting && <SubmittingLoader />}
                </span>
              </Grid2>
            </Grid2>
          </Grid2>
        </Form>
      )}
    </Formik>
  );
};

export default CreatePage;
